import type { ProjectsType } from "@/entities/projects/model/types";
import Typography from "@/shared/ui/Typography";
import { ProjectSlider } from "@/widgets/sliders/project_slider/ui";

interface INewApplicationSectionProps {
    projects: ProjectsType | undefined
}

export function NewApplicationSection({projects}: INewApplicationSectionProps) {

    if(!projects) 
        return 0

    return (
        <section className="relative flex flex-col gap-[20px] md:gap-[26px] pt-[52px] md:pt-[60px] pb-[20px] md:pb-[40px]">
            <div className="container">
                <Typography tag="h2">
                    Новые предложения
                </Typography>
            </div>

            <ProjectSlider
                projects={projects}
            />
        </section>
    );
}
